import { fetchChatMessages, type FetchChatMessagesResult } from "@/lib/chat/fetch-chat-messages"

export type { FetchChatMessagesResult } from "@/lib/chat/fetch-chat-messages"
export { ChatMessagesFetchError } from "@/lib/chat/fetch-chat-messages"

const TRANSIENT_STATUSES = new Set([401, 408, 429, 500, 502, 503, 504])

export async function fetchChatMessagesWithRetry(opts: {
  roomName: string
  limit: number
  before?: string
  maxAttempts?: number
}): Promise<FetchChatMessagesResult> {
  const maxAttempts = opts.maxAttempts ?? 2
  let lastError: unknown

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      return await fetchChatMessages(opts)
    } catch (error) {
      lastError = error
      const status =
        error && typeof error === "object" && "status" in error
          ? Number((error as { status: number }).status)
          : NaN
      const isTransient = TRANSIENT_STATUSES.has(status)
      if (!isTransient || attempt + 1 >= maxAttempts) throw error
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)))
    }
  }

  throw lastError
}
